import { render } from "./IndexJobs.vue?vue&type=template&id=019a4fbb"
import script from "./IndexJobs.vue?vue&type=script&lang=js"
export * from "./IndexJobs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__